import React from 'react';
import { Play, Pause, Square } from 'lucide-react';
import { Slider } from './ui/slider';

// Always-visible bottom transport bar on phones — Play/Pause, Stop,
// remaining time, brainwave state and volume without scrolling.
const MobileTransportBar = ({
  isPlaying,
  disabled,
  stopDisabled,
  onPlayPause,
  onStop,
  volume,
  onVolumeChange,
  timeLabel,
  stateName,
  stateColor,
}) => {
  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-[45] border-t border-white/10 bg-[#0a0e1a]/90 backdrop-blur-md px-3 pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))]"
      data-testid="mobile-transport-bar"
    >
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onPlayPause}
          disabled={disabled}
          data-testid="transport-play-btn"
          aria-label={isPlaying ? 'Pause' : 'Play'}
          className={`h-11 w-11 shrink-0 rounded-full flex items-center justify-center text-white shadow-lg transition-colors ${
            isPlaying ? 'bg-yellow-600 active:bg-yellow-700' : 'bg-green-600 active:bg-green-700'
          } disabled:opacity-50`}
        >
          {isPlaying ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
        </button>
        <button
          type="button"
          onClick={onStop}
          disabled={stopDisabled}
          data-testid="transport-stop-btn"
          aria-label="Stop"
          className="h-9 w-9 shrink-0 rounded-full flex items-center justify-center bg-red-600/90 active:bg-red-700 text-white disabled:opacity-40 transition-colors"
        >
          <Square className="w-4 h-4" />
        </button>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between text-[11px] leading-none mb-1.5">
            <span className="flex items-center gap-1.5 truncate text-white/70">
              <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ backgroundColor: stateColor || '#22d3ee' }} />
              <span className="truncate">{stateName || 'Ready'}</span>
            </span>
            <span className="font-mono text-white/80" data-testid="transport-time">{timeLabel}</span>
          </div>
          <Slider
            value={volume}
            onValueChange={onVolumeChange}
            max={1}
            min={0}
            step={0.05}
            data-testid="transport-volume"
          />
        </div>
      </div>
    </div>
  );
};

export default MobileTransportBar;
